module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



// WEBPACK FOOTER //
// ./~/browserify-sign/~/readable-stream/lib/internal/streams/from-browser.js